import { __awaiter } from "tslib";
import { checkTargeting } from 'pathfinder/modules/MarketingNotifications/utils/checkTargeting';
import { getAllActiveNotifications } from 'pathfinder/modules/MarketingNotifications/helpers/getAllActiveNotifications';
import { getActiveNotification } from 'pathfinder/modules/MarketingNotifications/helpers/activeNotification';
import { getAllActions, WEEK_PERIOD } from 'pathfinder/utils/actionsHelper';
import { ModuleType } from 'pathfinder/rules-engine/types';
import targetingDebug from 'pathfinder/modules/MarketingNotifications/utils/targetingDebug';
export const selectNotification = () => __awaiter(void 0, void 0, void 0, function* () {
    let debugStep = 0;
    let notifications = yield getAllActiveNotifications();
    targetingDebug('Active notifications fetched', [++debugStep], notifications);
    if (!notifications || !notifications.length) {
        return null;
    }
    let selectedNotification;
    const activeNotification = getActiveNotification(notifications);
    if (activeNotification) {
        targetingDebug('Active notification (from cookie)', [++debugStep], activeNotification);
        [selectedNotification] = yield checkTargeting([activeNotification], debugStep);
    }
    if (!selectedNotification) {
        const displayedNotifications = yield getAllActions(ModuleType.MarketingNotifications, window.SilverSurferSDK.ACTION.IMPRESSION);
        notifications = rejectBasedOnType(notifications, displayedNotifications);
        targetingDebug('Passed "notification type" rule', [++debugStep], notifications);
        notifications = rejectAlreadyDisplayed(notifications, displayedNotifications);
        targetingDebug('Passed "not yet displayed" rule', [++debugStep], notifications);
        const matchingNotifications = yield checkTargeting(notifications, ++debugStep);
        [selectedNotification] = sortByPriority(matchingNotifications);
    }
    targetingDebug('Final notification', [++debugStep], selectedNotification);
    return selectedNotification;
});
const rejectAlreadyDisplayed = (activeNotifications, displayedNotifications) => {
    if (!displayedNotifications.length) {
        return activeNotifications;
    }
    const displayedIds = displayedNotifications.map(({ payload }) => payload.id);
    return activeNotifications.filter(({ id }) => !displayedIds.includes(id));
};
const rejectBasedOnType = (activeNotifications, displayedNotifications) => {
    if (!displayedNotifications.length) {
        return activeNotifications;
    }
    const now = Date.now();
    const lastWeekNotifications = displayedNotifications.filter(({ time }) => now - time < WEEK_PERIOD);
    const displayedTypes = lastWeekNotifications.map(({ payload }) => payload.type);
    return activeNotifications.filter(({ type }) => !displayedTypes.includes(type));
};
const sortByPriority = (notifications) => {
    let Priority;
    (function (Priority) {
        Priority[Priority["High"] = 0] = "High";
        Priority[Priority["Medium"] = 1] = "Medium";
        Priority[Priority["Low"] = 2] = "Low";
    })(Priority || (Priority = {}));
    return notifications.sort((notification1, notification2) => Priority[notification1.priority] - Priority[notification2.priority]);
};
